'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'rv';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = 'M224 0L384 0l0 32 208 0 16 0 0 16 0 128 0 16-16 0-42.4 0L634 259.5l6 4.8 0 7.7 0 128 0 16-16 0-49.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16L400 416l-145.6 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2L4.7 315.3 0 310.6 0 304 0 48 0 32l16 0 208 0 0-32zM32 64l0 233.4 82.9 82.9C129.6 363 151.5 352 176 352c26.2 0 49.4 12.6 64 32l144 0 0-208 0-16 16 0 176 0 0-96L384 64l-32 0 0-32-96 0 0 32-32 0L32 64zM541.3 416a48 48 0 1 0 -90.5 32 48 48 0 1 0 90.5-32zM432 384c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32l48 0 0-96-192 0 0 96 16 0zm66.4-192L416 192l0 64 162.4 0-80-64zM221.3 416a48 48 0 1 0 -90.5 32 48 48 0 1 0 90.5-32zM128 160l0 64 160 0 0-64-160 0zM96 128l32 0 160 0 32 0 0 32 0 64 0 32-32 0-160 0-32 0 0-32 0-64 0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;